module.exports = __webpack_public_path__ + "static/media/NSF_4-Color_bitmap_Logo.426f2dff.png";